import { render, staticRenderFns } from "./senders-form-create.vue?vue&type=template&id=5583caea&"
import script from "./senders-form-create.vue?vue&type=script&lang=js&"
export * from "./senders-form-create.vue?vue&type=script&lang=js&"
import style0 from "./senders-form-create.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports